<template>
  <div class="chat-page">
    <div class="host vm-videochat vm-videomode">
      <div class="vm-videochat-wrapper">
        <div v-if="false" class="vm-videochat-side">
          <div class="vm-side-header">
            <button class="vm-exit-button">
              <i class="material-icons">exit_to_app</i>
            </button>
            <div class="vm-videochat-search-wrap">
              <input
                placeholder="Поиск..."
                class="vm-videochat-search"
                type="text"
              />
            </div>
          </div>
          <div class="vm-contacts">
            <div
              class="vm-contact"
              v-for="(contact, index) in contacts"
              :key="index"
            >
              <div class="vm-avatar">
                <div class="initials">
                  {{ contact.name.first.charAt(0) + contact.name.last.charAt(0) }}
                </div>
                <div v-if="contact.isOnline" class="vm-online-wrap">
                  <div class="vm-online"></div>
                </div>
              </div>
              <div class="vm-info">
                <div class="vm-name">
                  {{ contact.name.first }} {{ contact.name.last }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-else class="vm-videochat-side vm-video-side">
          <VideoSide
            v-if="frames"
            :frames="frames"
            :activeFrame="activeFrame"
          />
        </div> 
        <div class="vm-videochat-content">
          <div class="vm-videochat-header">
            <div class="vm-videochat-header-wrapper">
              <div class="vm-videochat-info">
                <div class="vm-videochat-title">{{ name }}</div>
                <div class="vm-videochat-subtitle">{{ count.total }} участников, {{ count.online }} онлайн</div>
              </div>
              <div class="vm-videochat-header-action">
                <button type="button">
                  <i class="material-icons">phone</i>
                </button>
              </div>
            </div>
          </div>

          <DynamicScroller
            @scroll.native.passive="handleScroll"
            ref="scroller"
            :items="messages"
            :min-item-size="1"
            class="vm-scroller"
            @resize="scrollToBottom()"
          >
            <DynamicScrollerItem
              slot-scope="{ item, index, active }"
              :item="item"
              :active="active"
              :data-index="index"
            >
              <div
                class="vm-message-wrap"
                :class="{
                  'vm-start': item.isStart,
                  'vm-end': item.isEnd,
                  'vm-middle': !item.isStart && !item.isEnd,
                  'vm-im': item.userId === user
                }"
              >
                <div v-if="item.isNextDay" class="vm-date">
                  {{ item.dayTitle }}
                </div>
                <div class="vm-message">
                  <div v-if="item.isStart" class="vm-title">
                    {{ item.user }}
                  </div>
                  <div v-if="typeof item.text !== 'undefined'" class="vm-text">
                    {{ item.text }}
                  </div>
                  <div v-else-if="item.file.type === 'file'" class="vm-file-block">
                    <div class="vm-download-icon">
                      <i class="material-icons">insert_drive_file</i>
                    </div>
                    <div class="vm-download-info">
                      <div class="vm-download-name">{{ item.file.name }}</div>
                      <div v-if="item.file.data" classs="vm-download-link">
                        <button @click="download(item.file.data)" type="button" class="vm-link-button">
                          Скачать
                        </button>
                      </div>
                    </div>
                  </div>
                  <div class="vm-message-image" v-else>
                    <img :src="item.file.data" alt="image" />
                  </div>
                  <div class="vm-time">
                    <i
                      v-if="item.status === 'wait'"
                      class="material-icons wait"
                    >
                      access_time
                    </i>
                    <i v-else class="material-icons">done_all</i>
                    {{ item.time }}
                  </div>
                </div>
              </div>
            </DynamicScrollerItem>
          </DynamicScroller>

          <div class="vm-videochat-footer">
            <div class="vm-videochat-action">
              <label class="vm-attach-button">
                <input
                  type="file"
                  @change="selectFiles"
                  id="attach-files"
                  class="upload-button"
                  multiple
                />
                <i class="material-icons">attach_file</i>
              </label>
            </div>
            <div class="vm-videochat-enterarea">
              <label for="enter"></label>
              <div class="vm-textarea-wrap">
                <ResizeAuto>
                  <textarea
                    id="enter"
                    placeholder="Введите сообщение..."
                    class="textarea"
                    rows="1"
                    @keydown.enter.exact.prevent="sendMessage"
                  ></textarea>
                </ResizeAuto>
              </div>
            </div>
            <div class="vm-videochat-action"></div>
            <div class="vm-videochat-action"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import ResizeAuto from './ResizeAuto';
import moment from 'moment';
import { delay } from 'lodash';
import 'moment/locale/fr';
import { chatApi } from '@app/services';
import VideoSide from './NextVideoSide';

moment.locale('ru');

export default {
  components: { ResizeAuto, VideoSide },
  data: () => ({
    activeFrame: null,
    mainFrame: null,
    frames: [],
    stream: null,
    name: null,
    count: {
      tota: 0,
      count: 0
    },
    message: '',
    loaders: {
      conversation: false,
      history: false
    },
    contacts: [],
    user: null,
    log: [],
    pagination: {
      limit: 3,
      offset: 0
    }
  }),
  beforeRouteUpdate (to, from, next) {
    const conversationId = +to.params.id;
    console.log({ conversationId });
    next();
  },
  async created() {
    const conversationId = +this.$route.params.id;
    chatApi.contacts$.subscribe(contacts => {
      this.count.total = contacts.length;
      this.count.online = contacts.filter(c => c.isOnline).length;
      this.contacts = contacts;
    });
    chatApi.main$.subscribe(({ name }) => this.name = name);
    chatApi.subscribers$.subscribe(frames => {
      const frame = frames.find(f => f.active);
      console.log('----->', { frame });
      this.activeFrame = {
        username: 'sdadasd',
        subscriber: frame.subscriber
      };
      this.frames = frames.map(({ subscriber }) => ({
        username: 'sdadasd',
        subscriber,
      }));
    });
    const { lastName, firstName, userId } = this.$store.state.permission;
    this.user = userId;
    chatApi.loadContacts(conversationId);
    chatApi.loadHistory(conversationId);
    await chatApi.connect(conversationId, { lastName, firstName, userId });
    await chatApi.startStreaming();
  },
  async mounted() {
    chatApi.chat$.subscribe(log => {
      this.log = log;
      this.scrollToBottom();
      setTimeout(() => this.scrollToBottom(), 400);
    });
  },
  destroyed() {
    chatApi.disconnect();
  },
  methods: {
    async download(url) {
      document.location.href = url;
    },
    selectFiles({ target }) {
      const { firstName, lastName, userId } = this.$store.state.permission;
      const user = {
        user: `${firstName} ${lastName}`,
        userId
      };
      target.files.forEach(async file => {
        await chatApi.sendMessage(user, undefined, file);
      });
    },
    async readFile(file) {
      const reader = new FileReader();
      return new Promise((resolve, reject) => {
        reader.onload = ({ target }) => resolve(target.result);
        reader.readAsDataURL(file);
      });
    },
    handleScroll({ target }) {
      const currentScroll = target.scrollTop;
      // console.log({ target });
      if (currentScroll === 0) {
        console.log('loadData');
      }
    },
    async loadConversations() {
      const { conversation } = await chatApi.getConversation(2);
      this.contacts = conversation.users.map();
    },
    async loadMessages() {
      console.log('start loadMessages');
      await this.sleep(1);
      console.log('complete loadMessages');
    },
    async sendMessage({ target }) {
      const text = target.value;
      if (target.value === '' || /^\s*$/i.test(target.value)) {
        target.value = '';
        target.style.height = '27px';
        return;
      }
      target.value = '';
      target.style.height = '27px';
      this.scrollToBottom();
      const { firstName, lastName, userId } = this.$store.state.permission;
      const user = {
        user: `${firstName} ${lastName}`,
        userId
      };
      chatApi.sendMessage(user, text);
    },
    scrollToBottom() {
      this.$refs.scroller.scrollToBottom();
    }
  },
  computed: {
    messages() {
      return this.log.map((message, index, messages) => {
        const past = {
          month: index
            ? new Date(messages[index - 1].timestamp).getMonth()
            : null,
          day: index ? new Date(messages[index - 1].timestamp).getDay() : null
        };
        const current = {
          month: index ? new Date(message.timestamp).getMonth() : null,
          day: index ? new Date(message.timestamp).getDay() : null
        };
        const next = {
          month:
            index !== messages.length - 1
              ? new Date(messages[index + 1].timestamp).getMonth()
              : null,
          day:
            index !== messages.length - 1
              ? new Date(messages[index + 1].timestamp).getDay()
              : null
        };
        const dayTitle = moment(message.timestamp).format('D MMMM');
        const time = moment(message.timestamp).format('HH:mm');
        const isNextDay =
          index === 0 ||
          past.month !== current.month ||
          past.day !== current.day;
        const isStart = isNextDay || message.user !== messages[index - 1].user;
        const isEnd =
          index === messages.length - 1 ||
          message.user !== messages[index + 1].user;
        return {
          ...message,
          id: index,
          isStart,
          isEnd,
          isNextDay,
          dayTitle,
          time
        };
      });
    }
  }
};
</script>

<style scoped>
.vm-message-image {
  display: flex;
}
.vm-message-image img {
  max-width: 100%;
  max-height: 300px;
}
.vm-link-button {
  display: inline;
  cursor: pointer;
  background-color: transparent;
  border: 0;
  padding: 0;
  margin: 0;
  outline: 0;
}
.vm-link-button:hover {
  color: rgb(87, 73, 207);
}
.vm-file-block {
  display: flex;
  padding: 6px 0;
  align-items: center;
}
.vm-download-icon {
  flex: 0 0 50px;
  width: 50px;
  height: 50px;
  background-color: rgba(255, 255, 255, 0.4);
  border-radius: 50%;
  margin-right: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.vm-download-icon i {
  color: rgb(99, 66, 209, 0.7);
}
.vm-download-name {
  font-weight: 600;
}
.list-enter-active,
.list-leave-active {
  transition: all 300ms;
}
.list-enter,
.list-leave-to {
  opacity: 0;
  transform: translateY(30px);
}
.vm-message-wrap {
  display: flex;
  flex-direction: column;
}
.vm-date {
  font-weight: 600;
  align-self: center;
  margin-bottom: 12px;
}
.vm-message {
  background-color: RGB(225, 201, 245);
  padding: 6px;
  border-radius: 6px 12px 12px 6px;
  align-self: flex-start;
}
.vm-im {
  justify-content: flex-end;
}
.vm-im .vm-message {
  background-color: RGB(205, 216, 242);
  border-radius: 12px 6px 6px 12px;
  align-self: flex-end;
}
.vm-im.vm-start .vm-message {
  border-radius: 12px 12px 6px 12px;
}
.vm-im.vm-end.vm-start .vm-message {
  border-radius: 12px 12px 0 12px;
}
.vm-im.vm-end .vm-message {
  border-radius: 12px 6px 0 12px;
}
.vm-start .vm-message {
  margin-bottom: 6px;
  border-radius: 12px 12px 12px 6px;
}
.vm-middle .vm-message {
  margin-bottom: 6px;
}
.vm-end .vm-message {
  margin-bottom: 12px;
  border-radius: 6px 12px 12px 0px;
}
.vm-start.vm-end .vm-message {
  border-radius: 12px 12px 12px 0;
}
.vm-message .vm-title {
  font-weight: 500;
  font-size: 16px;
  line-height: 1;
  margin-bottom: 6px;
  color: rgb(73, 30, 129)
}

.vm-side-footer {
  border-top: 1px solid rgba(255, 255, 255, 0.3);
}
.vm-exit-button {
  border: 0;
  background-color: transparent;
  color: #fff;
  outline: 0;
  height: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 0 0 60px;
}
.vm-exit-button i {
  transform: rotate(180deg);
  font-size: 36px;
}
.chat-page {
  height: calc(100vh - 64px);
  background-color: white;
}
.vm-videochat {
  max-width: 1248px;
  padding: 24px;
  margin: auto;
  height: 100%;
}
.vm-videochat-title {
  text-transform: uppercase;
  font-size: 18px;
  color: RGB(53, 40, 77);
  font-weight: 500;
}
.vm-videochat-wrapper {
  display: flex;
  height: 100%;
  border-radius: 4px;
  box-shadow: 0 2px 1px -1px rgba(0, 0, 0, 0.2), 0 1px 1px 0 rgba(0, 0, 0, 0.14),
    0 1px 3px 0 rgba(0, 0, 0, 0.12);
}
.vm-videochat-side {
  max-height: 100%;
  width: 300px;
  background: linear-gradient(to bottom, #8c30da, #5c48d4);
  /* background: linear-gradient(to right, rgb(242, 232, 251), rgb(234, 239, 250)); */
  border-radius: 4px 0 0 4px;
  z-index: 1;
  justify-content: space-between;
}
.vm-side-header {
  height: 60px;
  display: flex;
  align-items: center;
  border-bottom: 1px solid rgba(255, 255, 255, 0.3);
}
.vm-videochat-search-wrap {
  padding: 12px;
  padding-left: 0;
  width: 100%;
}
.vm-videochat-search {
  display: block;
  border: 0;
  background-color: rgba(255, 255, 255, 0.1);
  border-radius: 4px;
  width: 100%;
  color: #fff;
  padding-left: 24px;
  height: 36px;
  outline: none;
}
.vm-videochat-search::placeholder {
  color: #fff;
  font-weight: 300;
}
.vm-contacts {
  overflow-y: auto;
  height: calc(100% - 60px);
}
.vm-contact {
  padding-left: 12px;
  display: flex;
  align-items: center;
}
.vm-contact:last-child .vm-info {
  border-bottom: 0;
}
.vm-avatar {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 0 0 60px;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background-color: rgba(255, 255, 255, 0.4);
  font-weight: 500;
  font-size: 18px;
  color: #fff;
}
.vm-online-wrap {
  position: absolute;
  bottom: 2px;
  right: 2px;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background-color: RGB(87, 77, 128);
}
.vm-online {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background-color: RGBA(126, 198, 98, 1);
  background-clip: padding-box;
  border: 2px solid transparent;
}
.vm-info {
  flex: auto;
  border-bottom: 1px solid rgba(255, 255, 255, 0.3);
  padding: 12px;
  height: 60px;
  box-sizing: content-box;
}
.vm-name {
  font-weight: 500;
  color: #fff;
}
.vm-videochat-content {
  flex: auto;
  border-radius: 0 4px 4px 0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background: linear-gradient(to right, rgb(242, 232, 251), rgb(234, 239, 250));
}
.vm-videochat-header {
  height: 60px;
  flex: 0 0 60px;
  border-radius: 0 4px 0 0;
  padding: 0 24px;
}
.vm-videochat-header-wrapper {
  display: flex;
  height: 100%;
  align-items: center;
  padding: 0 12px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}
.vm-videochat-header-action {
  margin-left: auto;
}
.vm-videochat-header button {
  border: 0;
  outline: 0;
  background-color: #5c48d4;
  display: flex;
  color: #fff;
  border-radius: 50%;
  justify-content: center;
  align-items: center;
  width: 36px;
  height: 36px;
}
.vm-videochat-view {
  height: calc(100% - 120px);
  /*
  overflow-y: auto;
  padding: 24px;
  */
}
.vm-videochat-footer {
  min-height: 60px;
  background-color: white;
  border-radius: 0 0 4px 0;
  display: flex;
  flex-shrink: 0;
}
.vm-videochat-footer .vm-videochat-action {
  width: 60px;
  display: flex;
  align-items: flex-end;
}
.vm-videochat-enterarea {
  flex: auto;
  position: relative;
}
.vm-videochat-enterarea label {
  position: absolute;
  z-index: 1;
  margin: 0;
  padding: 0;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}
.vm-text {
  white-space: pre-line;
}
.vm-textarea-wrap {
  display: flex;
  align-items: center;
  height: 100%;
}
.vm-videochat-footer textarea {
  position: relative;
  z-index: 2;
  display: block;
  background-color: transparent;
  border: 0;
  width: 100%;
  outline: none;
  resize: none;
}
.vm-videochat-action label {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 60px;
  height: 60px;
  border: 0;
  background-color: transparent;
  transform: rotate(45deg);
  color: RGB(190, 190, 190);
  margin: 0;
  padding: 0;
  cursor: pointer;
}
.vm-videochat-action input {
  display: none;
}
.vm-videochat-action button i {
  font-size: 36px;
}
.vm-videochat-action label:hover i {
  color: rgb(122, 52, 213);
}
.vm-time {
  font-size: 13px;
  color: rgba(0, 0, 0, 0.6);
  font-weight: 300;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.vm-time i {
  font-size: 16px;
  margin-right: 4px;
  color: rgba(86, 72, 202, 0.7);
}
.vm-time i.wait {
  font-size: 16px;
  margin-right: 4px;
  color: rgba(0, 0, 0, 0.6);
}
.vm-attach-file-button {
  outline: 0;
}
/* virtual scroller */
.vm-scroller {
  height: 100%;
  padding: 24px;
  display: flex;
}
.vm-scroller >>> .vue-recycle-scroller__item-wrapper {
  margin-top: auto;
}
/* width */
::-webkit-scrollbar {
  width: 10px;
}

/* Track */
::-webkit-scrollbar-track {
  background: rgba(255, 255, 255, 0.3);
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.2);
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #555;
}
.vm-video-side {
  width: 800px;
  height: 100%;
}
</style>
